/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'


import SearchComp from "./search"
import GroupListComp from "./group_list"

const { rxaget } = global.rootRequire('classes/ulti')

// import { FixedSizeList,VariableSizeList } from 'react-window';
// global.isclient && require('./rxAccountInfo.css')
// const { rxsetLocal, rxgetLocal } = global.rootRequire('classes/request')
// const { rxaget, rxChangeSlug, stringToColour, autoConvertTime, subString ,changeColorSVG, isLeaderCheck} = global.rootRequire('classes/ulti')
// const { checkBlock, checkNameGroup, checkAvatarGroup, checkNameContact, checkNameUser, updateUsersOnline, getNumMemberOnl } = global.rootRequire('classes/chat')

// const { netaMediaAdd, netaGroupsUpdate, netaGroupsRemove, chooseGroupAction, changeStatusLoadMess, netaAuthSettingUpdate, clickPopup, clickCall, updateRecentContactGroups, netaAuthSettingSoundUpdate, updateRecentSearchGroups } = global.rootRequire('redux')
// const RxImageGallery = global.rootRequire('components/shares/rxImageGallery').default
const { netalogoutAction, setComp } = global.rootRequire('redux')
const rxio = global.rootRequire('classes/socket').default
// let zget = global.rxu.get

const chatDB = global.rootRequire('classes/indexedDB').default

const globalUser = global.rootRequire('classes/globalUser')

global.isclient && require('./index.css')





class GroupComponent extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}

    this.user = rxaget(this.props, 'netaauth.user', {})
    this.userid = rxaget(this.user, 'id', '')
    this.token = rxaget(this.user, 'token', '')


    // console.log(globalUser.users)


  }

  componentDidMount() {
    this.fetchRegisteredUsers()
    this.fetchContact()
  }

  componentWillUnmount() {
    
  }

  async fetchRegisteredUsers() {
    if (this.token) {
      const api_registered_users = global.rxu.config.registered_users
    
      const max_size = 100
      let arrUser = []

      for (let i = 0; i < 100; i++) {
        let checkBreak = true
        let offset = i
        const params = {
          offset: offset,
          limit: max_size,
          compact: 0
        }
        let tempBody = ''
        for (const property in params) {
          if (params.hasOwnProperty(property)) {
            tempBody += `${property}=${params[property]}&`
          }
        }

        try {
          let res = await fetch(api_registered_users + '?' + tempBody, { method: 'GET', headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }, body: null })
          try {
            let json = await res.json()
            if (res && [404, 401].indexOf(res.status) !== -1) {
              break
            }
            if (json && json.Code === 1021) {
              try {
                if (rxio.connected) {
                  rxio.disconnect()
                }

                this.props.netalogoutAction()
                this.props.setComp('login')

                chatDB.close()
                chatDB.delete().then(() => {
                  console.log("Database successfully deleted")
                  chatDB.open()
                }).catch((err) => {
                  chatDB.open()
                  console.error("Could not delete database")
                })
              } catch(e) {}
              break
            }

            if (json && json.items && json.items.constructor === Array && json.items.length > 0) {
              for (const itemreg of json.items) {
                const objreg = {
                  id: rxaget(itemreg, 'Id', ''),
                  uid: rxaget(itemreg, 'Id', ''),
                  email: rxaget(itemreg, 'email', ''),
                  phone: rxaget(itemreg, 'phone', ''),
                  full_name: rxaget(itemreg, 'full_name', ''),
                  profile_url: rxaget(itemreg, 'profile_url', ''),
                  name_contact: rxaget(itemreg, 'name_contact', '')
                }

                arrUser.push(objreg)

                // let userInDB = await chatDB.users.get({id: objreg.id})

                // if (!userInDB) {
                //   if (checkBreak === true) {
                //     checkBreak = false
                //   }
                // }
              }

              let iCheck = 0
              let arrNewUsers = await chatDB.users.bulkGet(arrUser.map(u => u.id))
              arrNewUsers = arrNewUsers.filter(Boolean)
              if (arrNewUsers.length !== json.items.length) {
                iCheck = 1
              }

              await chatDB.users.bulkPut(arrUser)

              if (iCheck == 0) {
                break
              }

              if (json.items.length < max_size) { 
                break 
              }
              
              if (checkBreak === true) {
                break 
              }
            } else {
              break
            }

          } catch (e) {
            break
          }
        } catch(e1) {}
        await new Promise(r => setTimeout(r, 1000));
      }
    }
  }


  async fetchContact () {  
    if (this.token) {
      const api_address_book = global.rxu.config.address_book
      const max_size = 300
      let checkBreak = true

      for (let i=0; i < 1000; i ++) {
        let offset = (i > 0) ? i*max_size - 1 : 0
        const params = {
          offset: offset,
          limit: max_size,
          compact: 0
        }
        let tempBody = ''
        for (const property in params) {
          if (params.hasOwnProperty(property)) {
            tempBody += `${property}=${params[property]}&`
          }
        }
        try {
          let res = await fetch(api_address_book + '?' + tempBody, { 
            method: 'GET', 
            headers: { 
              Accept: 'application/json', 
              'TC-Token': this.token, 
              Connection: 'Keep-Alive', 
              'Accept-Encoding': 'gzip' 
            }, body: null })

          let json = await res.json()
          if (res && [404,401].indexOf(res.status) !== -1) { checkBreak = true }
          else if (json && json.constructor === Array && json.length > 0) {
            checkBreak = false

            let iCheck = 0
            let arrNewContacts = await chatDB.contacts.bulkGet(json.map(o => o.phone))
            arrNewContacts = arrNewContacts.filter(Boolean)
            if (arrNewContacts.length !== json.length) {
              iCheck = 1
            }

            await chatDB.contacts.bulkPut(json)

            if (iCheck == 0) { checkBreak = true } 

            
            if (json.length < max_size) { checkBreak = true }
          }
        } catch(e) {
          checkBreak = true 
        }

        if (checkBreak === true) {
          break 
        }
        await new Promise(r => setTimeout(r, 2000));
      }
    }
  }

  callBackShowFooter() {
    this.props.callBackShowFooter()
  }

 
  render() {
    return (<div className='zleft_contain'>
      <SearchComp />
      <GroupListComp 
        oUser={this.user} 
        callBackShowFooter={() => this.callBackShowFooter()}
      />
    </div>)  
    
  }
}

const mapStateToProps = (state, ownProps) => ({
  netaauth: state.netaauth
})

const mapDispatchToProps = {
  netalogoutAction,
  setComp
}

const GroupComponentWrap = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupComponent)

export default GroupComponentWrap